<template lang="pug">
  tr.row.row-title
    th.col.blank
    th.col.blank
    th.col.check
      label.checkbox
        input(type="checkbox", :checked="checked", :disabled="isGlobalLocked", @click="check")
    th.col(v-for="v in columns", v-if="displayedColumns.includes(v.key)", :class="v.key")
      span {{ v.label }}
    th.col.account(v-if="leadManagementShareButton")
      span 取引先追加
</template>

<script>
  import { mapGetters, mapMutations, mapState } from 'vuex'

  export default {
    props: ['checked', 'leadManagementShareButton'],
    computed: {
      ...mapGetters('common', ['isGlobalLocked']),
      ...mapState({
        columns: state => state.companyTableConfiguration.columns,
        displayedColumns: state => state.companyTableConfiguration.displayedColumns,
      }),
    },
    methods: {
      ...mapMutations('companyTableConfiguration', ['sort']),
      check (event) {
        this.$emit('check', { event })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/CompanyTableHeader.vue